"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpretPercentageNode = void 0;
const matchStatus_1 = require("./matchStatus");
const rng_1 = require("./rng");
// Returns a boolean n percent of the time
function interpretPercentageNode(ruleNode, context, interpretChildren) {
    const bucketValue = context.getProperty(ruleNode.bucketKey);
    if (bucketValue == null) {
        context.sendError(`Property ${ruleNode.bucketKey} not found for dynamic value ${context.getDynamicValueName()} `);
        context.addResolutionLog(`Context missing bucket property: ${ruleNode.bucketKey}`);
        return matchStatus_1.error();
    }
    context.addResolutionDetails({
        bucket_key: bucketValue.toString(),
        bucket_key_type: ruleNode.bucketKey,
    });
    const bucketPercent = rng_1.getBucketPercent(String(bucketValue), context);
    const inBucket = bucketPercent < ruleNode.percent;
    context.addResolutionLog(inBucket
        ? `SUCCESS: ${bucketPercent} < ${ruleNode.percent}`
        : `FAILURE: ${bucketPercent} >= ${ruleNode.percent}`);
    return inBucket ? interpretChildren(ruleNode, context) : matchStatus_1.failure();
}
exports.interpretPercentageNode = interpretPercentageNode;
//# sourceMappingURL=percentageNode.js.map